import { PaymentStatus, DirectDebitInfo } from '../models/entities';
export function getBillingDocumentPaymentStatus(translate, billingDocument, billingAccountBalance) {
    var _a, _b, _c;
    if (((_a = billingDocument.paymentInfo) === null || _a === void 0 ? void 0 : _a.directDebitInfo) === DirectDebitInfo.ONGOING) {
        return {
            paymentText: translate('bills.billCard.directDebitOngoing.paymentText'),
            paymentTextColour: 'REGULAR',
        };
    }
    const dueDate = (_b = billingDocument.deferralDate) !== null && _b !== void 0 ? _b : billingDocument.dueDate;
    switch (billingDocument.paymentStatus) {
        case PaymentStatus.PAID:
            return {
                paymentText: translate('bills.billCard.paid.paymentText'),
                paymentTextColour: 'SUCCESS',
                paymentIcon: 'CHECK',
            };
        case PaymentStatus.OPEN:
            return getOpenBillingDocumentPaymentStatus(translate, dueDate, billingDocument.dueInDays, (_c = billingDocument.paymentInfo) === null || _c === void 0 ? void 0 : _c.directDebitInfo);
        case PaymentStatus.OVERDUE:
            return getOverdueBillingDocumentPaymentStatus(translate, dueDate, billingDocument.dueInDays, billingAccountBalance);
        case PaymentStatus.NOT_REFUNDED:
            return {
                paymentText: translate('bills.billCard.advantage.paymentText'),
                paymentTextColour: 'REGULAR',
            };
        case PaymentStatus.ONGOING_PAYMENT:
            return {
                paymentText: translate('bills.billCard.ongoing.paymentText'),
                paymentTextColour: 'REGULAR',
            };
        case PaymentStatus.INSTALMENT:
            return {
                paymentText: translate('bills.billCard.instalment.paymentText'),
                paymentTextColour: 'WARNING',
            };
        case PaymentStatus.REFUNDED:
            return {
                paymentText: translate('bills.billCard.processed.paymentText'),
                paymentTextColour: 'SUCCESS',
                paymentIcon: 'CHECK',
            };
        default:
            return { paymentTextColour: 'REGULAR' };
    }
}
function getOpenBillingDocumentPaymentStatus(translate, dueDate, dueInDays, directDebitInfo) {
    if (directDebitInfo !== undefined && directDebitInfo !== DirectDebitInfo.MANUAL) {
        return {
            paymentText: translate('bills.billCard.directDebit.paymentText', {
                date: '{{date}}',
            }).replace(/{{date}}/g, dueDate),
            payButtonTitle: translate('bills.billCard.mainActionTitle'),
            paymentTextColour: 'REGULAR',
        };
    }
    let paymentText;
    let paymentIcon;
    let paymentTextColour = 'REGULAR';
    if (dueInDays !== null) {
        const dueInDaysNumber = Number(dueInDays);
        if (dueInDaysNumber === 0) {
            paymentIcon = 'WARNING';
            paymentTextColour = 'ERROR';
            paymentText = translate('bills.billCard.overdue.is0Days');
        }
        else if (dueInDaysNumber >= 1 && dueInDaysNumber <= 4) {
            paymentIcon = 'WARNING';
            paymentTextColour = 'WARNING';
            paymentText =
                translate('bills.billCard.overdue.isBetween4And1Days') +
                    dueInDays +
                    translate('bills.billCard.overdue.isBetween4And1DaysEnd');
        }
        else {
            paymentText = translate('bills.billCard.overdue.isMoreThan4Days') + dueDate;
        }
    }
    return {
        paymentText,
        payButtonTitle: translate('bills.billCard.mainActionTitle'),
        paymentTextColour,
        paymentIcon,
    };
}
function getOverdueBillingDocumentPaymentStatus(translate, dueDate, dueInDays, billingAccountBalance) {
    if (Number(billingAccountBalance) < 0) {
        return {
            paymentText: translate('bills.billCard.overdue.isMoreThan4Days') + dueDate,
            payButtonTitle: translate('bills.billCard.mainActionTitle'),
            paymentTextColour: 'REGULAR',
            paymentIcon: undefined,
        };
    }
    let paymentText;
    if (dueInDays !== null) {
        const dueInDaysNumber = Number(dueInDays);
        const daysEnd = translate(dueInDaysNumber === -1
            ? 'bills.billCard.overdue.isLessOrEqual1DaysEnd'
            : 'bills.billCard.overdue.isBetween4And1DaysEnd');
        paymentText =
            translate('bills.billCard.overdue.isLessThan0Days') +
                ' ' +
                String(Math.abs(dueInDaysNumber)) +
                daysEnd;
    }
    return {
        paymentText,
        paymentTextColour: 'ERROR',
        paymentIcon: 'WARNING',
        payButtonTitle: translate('bills.billCard.mainActionTitle'),
    };
}
